<template>
  <form class="form ck-player_add-image-form" action="POST">
        <label for="thumbnail" class="ck-player_add-image">
            <img :src="(imagepath) ? imagepath : '/images/person_placeholder.jpeg'" alt="" class="ck-player_image">
        </label>
        <input @change="uploadImage" class="input is-sr" type="file" name="thumbnail" id="thumbnail">
    </form>
</template>

<script>
export default {
    props: ['playerid'],
    data() {
        return {
            imagepath: null
        }
    },
    methods: {
        uploadImage() {
          let data = new FormData();
          data.append('thumbnail', document.getElementById('thumbnail').files[0]);

          axios.post(`/thumbnails/player/${this.playerid}`, data).then(res => {
              var img = document.getElementById('ck-player_thumbnail-image')

              this.imagepath = '/storage/' + res.data;
          }).catch(e => {
          });
        }
    }

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/ckAddPersonThumbnail.vue